import { useSessionContext } from '@shared/hooks'
import { getTokenFromUrl } from '@shared/utils'

export const useAppPath = () => {
  const { broker } = useSessionContext()

  const token = broker ? broker.token : getTokenFromUrl()

  if (!token) {
    console.error('Token is missing or invalid.')
    return
  }

  return `/apps/insurance/${token}`
}
